import { atom } from 'recoil';

export const authStateAtom = atom<string | undefined>({
  key: 'authState',
  default: undefined,
});
